module.exports = __webpack_public_path__ + "img/119ne.b91b6929.svg";